import Api from './Api'

const END_POINT = 'transfers'

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async get_all_paginated(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-paginated`, request)
    },

    async store(transfer) {
        return await Api.post(`${END_POINT}`, transfer)
    },

    async detail(transfer) {
        return await Api.get(`${END_POINT}/${transfer.id}/detail`)
    },

    async receive(transfer) {
        return await Api.post(`${END_POINT}/${transfer.id}/receive`, transfer.detail)
    },

    async cancel(transfer) {
        return await Api.post(`${END_POINT}/${transfer.id}/cancel`)
    },
}